// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9e-4";
export var collapsed = "_9e-1";
export var headerBar = "_9e-0";
export var leftHeaderContent = "_9e-3";
export var subjectContainer = "_9e-2";